import * as React from "react";
import { useAppointmentContext } from "../../../../../../../context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { getBookAppointmentStore } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-store-by-id.js";
import { getBookAppointmentType } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-type.js";
import { InvalidVirtualAppointmentError, AlternativeUrlStoreError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError, AlternativeLinkedAppointmentTypeNotValidError } from "../../../../../../../v3/pages/BookAppointment/errors.js";
import { getFormattedParams, hasValidVirtualAppointmentParams, generateVirtualAppointmentStoreByIdData, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from "../../../../../../../v3/pages/BookAppointment/utils.js";
import AppointmentLocationContainer from "../../../../../../../../../components/AppointmentLocation/v3/components/AppointmentLocation/AppointmentLocationContainer.js";
const WhereRoot = () => {
  const [, { type }] = useAppointmentContext();
  return /* @__PURE__ */ React.createElement(AppointmentLocationContainer, { appointmentTypeId: type?.id });
};
WhereRoot.getServerSideProps = async (apolloClient, params, locale) => {
  const formattedParams = getFormattedParams(params);
  let promises = [null, null, null, null];
  if (hasValidVirtualAppointmentParams(formattedParams)) {
    const type2 = await getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
    promises = [
      type2 ? generateVirtualAppointmentStoreByIdData(formattedParams.virtualStoreCode, type2) : null,
      // TODO: MACC-19077 formattedParams.virtualStoreCode is always a string. Remove as string before merging to master.
      type2,
      null,
      null
    ];
  } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
    throw InvalidVirtualAppointmentError();
  } else {
    promises = [
      getBookAppointmentStore(
        apolloClient,
        formattedParams.globalStoreId,
        locale,
        formattedParams.tryInStoreFlow,
        formattedParams.groupId
      ),
      getBookAppointmentType(apolloClient, formattedParams.typeId, locale),
      getBookAppointmentType(apolloClient, formattedParams.linkedAppointmentTypeId, locale),
      getBookAppointmentType(
        apolloClient,
        formattedParams.alternativeLinkedAppointmentTypeId,
        locale
      )
    ];
  }
  const [store, type, linkedAppointmentType, alternativeLinkedAppointmentType] = await Promise.all(promises);
  if (formattedParams.globalStoreId && formattedParams.alternativeUrlStores?.includes(formattedParams.globalStoreId)) {
    throw AlternativeUrlStoreError();
  } else if (formattedParams.globalStoreId && !store) {
    throw StoreNotFoundError();
  } else if (formattedParams.typeId && !type) {
    throw TypeNotFoundError();
  } else if (store && type && !isAppointmentTypeValid({
    typeId: type?.id,
    store
  })) {
    throw TypeNotAvailableForStoreError();
  } else if (formattedParams?.linkedAppointmentTypeId && !linkedAppointmentType) {
    throw LinkedAppointmentTypeNotValidError();
  } else if (formattedParams?.alternativeLinkedAppointmentTypeId && !alternativeLinkedAppointmentType) {
    throw AlternativeLinkedAppointmentTypeNotValidError();
  }
  return Promise.resolve({
    store,
    type,
    timeSlot: null
  });
};
export {
  WhereRoot as default
};
//# sourceMappingURL=WhereRoot.js.map
